import React, { useState } from "react";
import {
  Button,
  Typography,
  Badge,
  Alert,
  Divider,
  Checkbox,
  Card,
  Popconfirm,
} from "antd";
import "./modalStyles.css";

import { CloseOutlined, StarOutlined } from "@ant-design/icons";
import { addInlineStylesToTags } from "../../../pages/Admin-pages/CA-admin-pages/Communications/helper";
import { MAIN_LOGO_BIG } from "../../../ImagesSrc";
const { Title, Text } = Typography;
const MaintainenceModal = ({
  formData,
  links,
  applications,
  content,
  useStructuredPoints,
}) => {
  // console.log(formData, links);
  const handleDontShowAgain = () => {
    localStorage.setItem("hideDowntimeModal", "true");
  };

  const [dontShow, setDontShow] = useState(false);

  const handleCheckboxChange = (e) => {
    setDontShow(e.target.checked);
  };
  const renderCustomPoints = () => {
    return formData?.customPoints
      ?.filter((item) => item && item.point) // Filter out undefined/null and items without a point
      .map((item, index) => {
        const link = links?.[index]; // Get the corresponding link from formData.links
        const hasLink = link && link.name && link.url; // Check if link exists

        return (
          <div key={index}>
            <Text className="text-loc-modal">
              <StarOutlined
                style={{ marginRight: "7.5px", fontSize: "12px" }}
              />
              {item?.point || ""}
              {/* If a link is present, add it */}
              {hasLink && (
                <>
                  {" "}
                  <a href={link.url} target="_blank" rel="noopener noreferrer">
                    {link.name}
                  </a>
                </>
              )}
            </Text>
            {index !== formData.customPoints.length - 1 && (
              <Divider style={{ margin: "5px 0" }} />
            )}
          </div>
        );
      });
  };
  const isProduct = formData?.sub_category === "Product Announcement";
  const matchedApplication =
    formData?.application === -1
      ? MAIN_LOGO_BIG
      : applications?.find((app) => app.id === formData?.application)?.logo ||
        MAIN_LOGO_BIG;
  const BadgeStatus = isProduct
    ? "success"
    : formData?.priority === "High"
    ? "error"
    : "warning";
  const BadgeText = isProduct
    ? "New Announcement"
    : formData?.priority === "High"
    ? "High Priority"
    : "Low Priority";
  const alertBoxColor = isProduct ? "info" : "warning";
  // const currentIndex = 0;
  // const twoColors = {
  //   "0%": "#108ee9",
  //   "100%": "#87d068",
  // };

  return (
    <Card hoverable style={{ width: "800px" }}>
      <div className="modal-header">
        <div className="modal-title-container">
          <Badge
            status={BadgeStatus}
            text={BadgeText}
            className="blinking-badge"
            size="small"
          />
          <Title level={4} className="modal-title">
            {formData?.title || "Enter Your Title"}
          </Title>
        </div>
        <img src={matchedApplication} alt="App Logo" className="app-logo" />
      </div>

      {/* Information */}
      <Alert
        style={{ margin: "10px" }}
        description={
          <>
            {useStructuredPoints ? (
              <Text className="text-loc-modal">{renderCustomPoints()}</Text>
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: addInlineStylesToTags(content),
                }}
              />
            )}
          </>
        }
        type={alertBoxColor}
      />
      <Divider style={{ marginBottom: "15px", marginTop: "15px" }} />

      <div
        style={{
          display: "flex",
          alignItems: "center",

          marginInline: "25px",
        }}
      >
        <Text type="secondary">
          Need help? Contact{" "}
          <a href="mailto:support@example.com">support@trainery.one</a>
        </Text>
      </div>

      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "5px",
        }}
      >
        <Popconfirm
          title="You can enable this option after reading all product announcements."
          trigger="hover"
          showCancel={false}
        >
          <Checkbox
            onChange={handleCheckboxChange}
            checked={dontShow}
            disabled={false}
          >
            Don't show this again
          </Checkbox>
        </Popconfirm>
        <Button
          type="default"
          className="modal-btn close-btn"
          onClick={handleDontShowAgain}
          style={{ width: "25%" }}
        >
          <CloseOutlined />
          Close
        </Button>
      </div>
    </Card>
  );
};

export default MaintainenceModal;
/*      {!isProduct ? (
        <div
          className="support-info"
          style={{
            marginTop: "15px",
            display: "flex",
            alignItems: "center",
            gap: "15px",
            marginInline: "27.5px",
          }}
        >
          <Text type="secondary">
            Need help? Contact{" "}
            <a href="mailto:support@example.com">support@trainery.one</a>
          </Text>
        </div>
      ) : (
        <>
          {true && (
            <div
              className="announcement-footer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "25px",
              }}
            >
              <Button type="default" onClick={() => {}} disabled>
                <ArrowLeftOutlined />
              </Button>

              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "5px",
                }}
              >
                <Progress
                  percent={((currentIndex + 1) * (100 / 2)).toFixed(2)}
                  strokeColor={twoColors}
                  status="active"
                />
              </div>

              <Button type="primary" onClick={() => {}}>
                <ArrowRightOutlined />
              </Button>
            </div>
          )}
        </>
      )}
 */
